export default "__VITE_ASSET__DAd4kQa3__"